// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : react hooks for tree component
// =============================================================================
// ---Third-party imports
// ---Framework imports
import { Sel } from 'uix/registries';
import { size, get, has } from 'ldash';
import log from 'uix/logging';
// ---Local imports
import { useSelector, useActions, useEffect } from 'uix/hooks';
import { getUserData } from './actions';
// ---Exports
export const useUserData = (puid)=>{
    let users = useSelector((root)=>root.data.users);
    let actions = useActions({
        getUserData
    });
    useEffect(()=>{
        if (puid && !has(users, puid)) {
            actions.getUserData({
                puid
            });
        }
    }, [
        actions
    ]);
    return users[puid];
};
